import React, { useEffect } from "react";
import AccountTableHead from "../../components/Accounts/AccountTableHead";
import AccountTransactionTable from "../../components/Accounts/AccountTransactionTable";
import EmptyDashBoard from "../../components/DashBoardComponents/EmptyDashBoard";
import {
  TableContainer,
  Paper,
  Table,
  TableBody,
  TableHead,
} from "@mui/material";
import { columnTitle, transactionData, widths } from "./data";
import AccountTransactionTableBody from "../../components/Accounts/AccountTransactionTableBody";
import { useQuery } from "@apollo/client";
import { getTransfersByUserId } from "../../graphql/queries/accounts";
import { useSelector } from "react-redux";
import { RootState } from "../../store/rootReducer";

export interface TransferDetails {
  createdAt: string;
  amount: number;
  transferType: string;
  id: string;
  purpose: string;
  recipientTag: string;
  transferStatus: string;
  transferFee: string;
  paymentChannel?: string;
  recipientAccountId?: string;
  recipientAccountNumber?: string;
  recipientAddress?: string;
  recipientBankName?: string;
  recipientPhoneNumber?: string;
  recipientFullName?: string;
  [key: string]: any;
}

const TransactionTable = () => {
  const id = useSelector((state: RootState) => state.user?.user.id);

  const {
    loading: queryLoading,
    error: queryError,
    data: queryData,
    refetch: refetchTransfers,
  } = useQuery(getTransfersByUserId);

  const transactionDetails: TransferDetails[] =
    queryData?.getTransfersByUserId?.transfers || [];
  const fetchedTransactionDetails = transactionDetails?.map((item) => {
    const obj = {
      ...transactionData,
      date: item.createdAt,
      description: item.purpose,
      amount: item.amount,
      paymentType: item.transferType,
      transactionId: item.id,
      status: item.transferStatus,
      transferFee: item.transferFee,
      paymentChannel: item.paymentChannel,
      recipientTag: item.recepientTag,
      recipientAccountNumber: item.recipientAccountNumber,
      recipientBankName: item.recipientBankName,
      recipientPhoneNumber: item.recipientPhoneNumber,
      recipientFullName: item.recipientFullName,
    };
    return obj;
  });

  useEffect(() => {
    refetchTransfers();
  }, [id]);

  return (
    <>
      <AccountTransactionTable />
      <TableContainer component={Paper} sx={{ width: "100%" }}>
        <Table sx={{ width: "100%" }}>
          <TableBody sx={{ width: "100%" }}>
            <TableHead
              sx={{
                width: "100%",
                backgroundColor: "#F7F7F7",
                display: "flex",
              }}
            >
              {columnTitle.map((item, index) => (
                <AccountTableHead title={item} width={widths[index]} />
              ))}
            </TableHead>
            {fetchedTransactionDetails?.length === 0 ? (
              <EmptyDashBoard
                titleText={
                  queryLoading
                    ? "Loading transactions..."
                    : "No Transaction History"
                }
                specialStyle={true}
              />
            ) : (
              fetchedTransactionDetails?.map((data, index) => (
                <AccountTransactionTableBody
                  rowObj={data}
                  key={`${data.date}-${index}`}
                />
              ))
            )}
          </TableBody>
        </Table>
      </TableContainer>
    </>
  );
};

export default TransactionTable;
